export const TimePeriodDesignationKey = {
    morning: "gblWelcomeMorning",
    afternoon: "gblWelcomeAfternoon",
    evening: "gblWelcomeEvening"
};
